import React from 'react';
import { Grid } from '@material-ui/core';

import { FormTextField } from '../../components';
import { FilterBySelect } from '../../pageComponents/Filters';

export const FilterByName = (props) => (
	<Grid item md={3} sm={3} xs={12}>
		<FormTextField
			{...props}
			id="proxy-filter-by-name"
			data-apim-test="proxy-filter-by-name"
		/>
	</Grid>
);

export const FilterByKeyStoreName = (props) => (
	<Grid item md={3} sm={2} xs={12}>
		<FormTextField
			{...props}
			id='proxy-filter-by-key-store-name'
			data-apim-test='proxy-filter-by-key-store-name'
		/>
	</Grid>
);

export const FilterByConnectionStatus = (props) => (
	<Grid item md={2} sm={2} xs={12}>
		<FilterBySelect
			{...props}
			id="proxy-filter-by-connection-status"
			data-apim-test="proxy-filter-by-connection-status"
		/>
	</Grid>
);

export const FilterSeparator = () => (
	<Grid item md={4}/>
);